var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9528 2.41498C17.3337 3.89998 17.3337 6.99998 17.3337 6.99998C17.3337 6.99998 17.3337 10.1 16.9528 11.585C16.7412 12.4058 16.122 13.0516 15.3378 13.27C13.9137 13.6666 9.00033 13.6666 9.00033 13.6666C9.00033 13.6666 4.08949 13.6666 2.66283 13.27C1.87533 13.0483 1.25699 12.4033 1.04783 11.585C0.666992 10.1 0.666992 6.99998 0.666992 6.99998C0.666992 6.99998 0.666992 3.89998 1.04783 2.41498C1.25949 1.59415 1.87866 0.948313 2.66283 0.729979C4.08949 0.333313 9.00033 0.333313 9.00033 0.333313C9.00033 0.333313 13.9137 0.333313 15.3378 0.729979C16.1253 0.951646 16.7437 1.59665 16.9528 2.41498ZM7.33366 9.91665L12.3337 6.99998L7.33366 4.08331V9.91665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2);
export default __webpack_public_path__ + "static/media/youtube2.8d3e7644672b89036602020214b52548.svg";
export { ForwardRef as ReactComponent };